import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const Faq = () => {
  return (
    <div>
      <Navbar />
        <section className="in_page p70 bg4 pb-0">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">FAQs</h1>
              
            </div>
            <div className="col-md-4 m-auto col-8">
              <img
                src="/img/faq.png"
                alt="faq"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
       <section className="in_page p70">
          <div className="container"> 
              <h3 className="">General</h3>
               <div className="br10 p-2 p-md-4 bg2 mb-4"> 
                <h5 className="mb-3">Which asset classes does Dyntech support?</h5>
                <p className="mb-0">We support equities, FX, commodities, digital assets, and derivatives—either out of the box or via custom integrations. </p> 
              
                <h5 className="mb-3 mt-4 mt-md-5">Can I deploy Dyntech on-premises or in the cloud?</h5>
                <p className="mb-0"> Yes. Our platform is fully containerized, allowing deployment in your private datacenter, public cloud (AWS, Azure, GCP), or a hybrid model.</p>
              </div>
              <h3 className="">Platform & Development</h3>
               <div className="br10 p-2 p-md-4 bg2 mb-4"> 
                <h5 className="mb-3">How long does it take to launch a new trading platform?</h5>
                <p className="mb-0">It depends on customization scope and regulatory onboarding.</p> 
              
                <h5 className="mb-3 mt-4 mt-md-5"> Do you provide API documentation?</h5>
                <p className="mb-0">Yes. We supply comprehensive REST/WebSocket API docs, sample code, and SDKs in multiple languages.</p>
              </div>

              <h3 className="">Partnerships & Support</h3>
               <div className="br10 p-2 p-md-4 bg2 mb-4"> 
                <h5 className="mb-3"> What partnership models do you offer?</h5>
                <ul className="list">
                  <li><b>White-Label: </b> Fully branded, turn-key solution.</li>
                  <li><b>Technology Licensing: </b> Integrate our engine with your front end.</li>
                  <li><b>Custom Development:</b>  From blockchain projects to bespoke analytics.</li>
                </ul>
              
                <h5 className="mb-3 mt-4 mt-md-5">What SLAs are available?</h5>
                <p className="mb-0">  We offer standard (99.9% uptime) and premium (99.99% uptime with 24/7 on-call engineer) SLAs.</p>
              </div>

               <h3>Support FAQs</h3>
               <div className="br10 p-2 p-md-4 bg2 mb-4"> 
                  <h5 className="mb-3 ">How long does a fiat withdrawal take?</h5>
               <p className="mb-0"> Typically 1–3 business days for bank transfers; instant for most cryptocurrencies once network confirmations complete.</p>
              
                <h5 className="mb-3 mt-4 mt-md-5">Are there deposit fees?</h5>
                <p className="mb-4"> Dyntech does not charge deposit fees, but your bank or payment provider may. Check their fee schedule.</p>

                <p className="mb-0">Open a ticket in the Help Center or email support@dyntech.com.</p>
              </div>

              <b>Still have questions?</b>
              <p>Reach out via support@dyntech.com or open a ticket in our Help Center.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Faq;
